import * as React from "react";

import GenButton from "./Button";
import GenLoadingSpinner from "./LoadingSpinner";

interface GenMoreProps extends ConnectedList<any>
 {
  shouldInfiniteScroll?: boolean;
  noItemsMessage?: string
}

export default function GenMore({
  isSyncing,
  per_page=12,
  lastPageLength,
  readListPage,
  shouldInfiniteScroll,
  listData,
  noItemsMessage,
  search,
  activeFilters,
}: GenMoreProps) {
  const infiniteScrollRandomKey = React.useId();

  const checkVisibilityForInfiniteScroll = React.useCallback(() => {
    const element = document.getElementById(infiniteScrollRandomKey);
    if (element) {
      const elementRect = element.getBoundingClientRect();
      const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
      const isVisible = !(elementRect.bottom < 0 || elementRect.top - viewHeight >= 0);

      if (isVisible) {
        readListPage();
      }
    }
  }, []);

  React.useEffect(() => {
    let checkVisibilityTimer: ReturnType<typeof setTimeout>;
    if (shouldInfiniteScroll) {
      window.addEventListener("scroll", checkVisibilityForInfiniteScroll);
      checkVisibilityTimer = setInterval(checkVisibilityForInfiniteScroll, 500);
    }

    return () => {
      if (shouldInfiniteScroll) {
        window.removeEventListener("scroll", checkVisibilityForInfiniteScroll);
        clearTimeout(checkVisibilityTimer);
      }
    };
  }, [checkVisibilityForInfiniteScroll, shouldInfiniteScroll]);

  if (isSyncing) {
    return <GenLoadingSpinner />;
  } else if (typeof lastPageLength === "number" && lastPageLength < per_page) {
    if (listData?.length === 0) {
      const hasActiveSearchOrFiltering = (search && search.length > 0) || (activeFilters && Object.keys(activeFilters).length > 0);

      return (
        <div className="gen-list-pagination flex justify-center">
          { !hasActiveSearchOrFiltering && noItemsMessage ? <h5>{noItemsMessage}</h5> : <GenButton name="No Items" highlighted disabled /> }
        </div>
      );
    } else {
      return (
        <div className="gen-list-pagination flex justify-center">
          <GenButton name="End" highlighted disabled />
        </div>
      );
    }
  } else if (shouldInfiniteScroll) {
    return (
      <div className="gen-list-pagination">
        <div id={infiniteScrollRandomKey} className="infinite-scroll-area" />
      </div>
    );
  } else {
    return (
      <div className="gen-list-pagination flex justify-center">
        <GenButton name="More" onClick={() => readListPage()} highlighted />
      </div>
    );
  }
}
